// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderTrackOrder: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 24 20" width={width} height={height}>
            <path
                fill="currentColor"
                d="M2.4 2.063c-.664 0-1.2.53-1.2 1.187v10.688c0 .656.536 1.187 1.2 1.187h.206A3.6 3.6 0 0 1 6 12.75c1.568 0 2.902.99 3.394 2.375H14.4V3.25c0-.657-.536-1.187-1.2-1.187zm0 14.25c-1.324 0-2.4-1.066-2.4-2.375V3.25C0 1.94 1.076.875 2.4.875h10.8c1.324 0 2.4 1.065 2.4 2.375v1.188h2.449c.525 0 1.023.226 1.365.623l2.951 3.407c.281.322.435.734.435 1.157v5.5h.6c.33 0 .6.267.6.594s-.27.594-.6.594h-1.8c0 1.966-1.613 3.562-3.6 3.562s-3.6-1.596-3.6-3.562H9.6c0 1.966-1.612 3.562-3.6 3.562s-3.6-1.596-3.6-3.562m13.2-7.125h5.809l-2.906-3.355a.6.6 0 0 0-.454-.208H15.6zm0 1.187v3.28a3.6 3.6 0 0 1 2.4-.905c1.567 0 2.903.99 3.394 2.375h.206v-4.75zm-7.2 5.938a2.37 2.37 0 0 0-1.2-2.057 2.42 2.42 0 0 0-2.4 0 2.37 2.37 0 0 0-1.2 2.057 2.37 2.37 0 0 0 1.2 2.056 2.42 2.42 0 0 0 2.4 0 2.37 2.37 0 0 0 1.2-2.056m9.6 2.375c.857 0 1.65-.453 2.078-1.188a2.35 2.35 0 0 0 0-2.375A2.4 2.4 0 0 0 18 13.938c-.857 0-1.65.452-2.078 1.187a2.35 2.35 0 0 0 0 2.375A2.4 2.4 0 0 0 18 18.688"
            />
        </svg>
    );
};

export default React.memo(HeaderTrackOrder);
